import { render, staticRenderFns } from "./CardInfoWidget.vue?vue&type=template&id=259bd58d&scoped=true"
import script from "./CardInfoWidget.vue?vue&type=script&lang=js"
export * from "./CardInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./CardInfoWidget.vue?vue&type=style&index=0&id=259bd58d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259bd58d",
  null
  
)

export default component.exports